define('formkit/view/form.object/content/date.time.content.view',['require','exports','module','uikit/uikit','./base.input.content.view','../../../templates','moment','moment-tz'],function(require, exports, module){
  var UIKit                = require('uikit/uikit');
  var BaseInputContentView = require('./base.input.content.view');
  var Templates            = require('../../../templates');
  var moment               = require('moment');
  var momentTZ             = require('moment-tz');

  // Moment's recommended workaround to get only canonical timezone names from their packed data
  // since we don't want to display aliases or obsolete timezone names
  // See https://github.com/moment/moment-timezone/issues/227#issuecomment-194932242
  var CANONICAL_TIMEZONE_NAMES = Object.keys(moment.tz._zones)
                                       .map(function(k) { return moment.tz._zones[k].split('|')[0]; })
                                       .filter(function(z) { return z.indexOf('/') >= 0; })
                                       .sort();

  var PreviewAnswerView = BaseInputContentView.PreviewAnswerView.extend({
    template:Templates.App['date.time.content'],

    internalViewOptions: BaseInputContentView.PreviewAnswerView.extendInternalViewOptions({
      dateView: function() {
        return {
          type: UIKit.InputDate,
          fluid: true,
          fixed: true,
          readonly: this.getOption('readonly')
        }
      },

      timeView: function() {
        return {
          type: UIKit.InputTime,
          fluid: true,
          readonly: this.getOption('readonly'),
          // UIKit.InputTime has no concept of "readonly", but the UIKit.Dropdown it builds does, so we apply the readonly
          // state to that component before rendering the view
          behaviors: {
            applyReadonlyState: {
              behaviorClass: Mn.Behavior.extend({
                onFirstBeforeRender: function(inputTimeView) {
                  inputTimeView.dropdown.readonly = inputTimeView.getOption('readonly');
                }
              })
            }
          }
        }
      },

      timezoneView: function() {
        return {
          type: UIKit.Dropdown,
          placeholder: 'Select timezone...',
          collection: new Backbone.Collection(),
          search: true,
          fluid: true,
          readonly: this.getOption('readonly'),
          disabled: true,
          bindings: {
            text: 'displayName'
          },
          childBindings: {
            text: 'displayName',
          }
        }
      }
    }),

    selectedDate: null,
    selectedTime: null,
    selectedTimezone: null,

    onFirstBeforeRender: function() {
      var answerValueModel = this.getAndLinkAnswerValueModel(this.model, this.form);
      var componentValuesArray;

      this.timezoneView.collection.add( this.getFormattedCanonicalTimezoneObjectsArray() );

      // before we do the initial rendering of the view, we need to check and see if a previous answer value has been given
      // and if so, we need to parse it and initialize the date, time, and timezone views.
      if (answerValueModel.get('value')) {
        componentValuesArray = this.parseDateTimeAndTimezoneString(answerValueModel.get('value'));
        this.dateView.value = componentValuesArray[0];
        this.timeView.value = componentValuesArray[1];
        this.timezoneView.value = this.timezoneView.collection.findWhere({ name: componentValuesArray[3] });
        this.timezoneView.disabled = false;
      }
    },

    getFormattedCanonicalTimezoneObjectsArray: function() {
      // moment-tz needs a date and a timezone name in order to produce a formatted UTC offset. The offset is independent
      // of the date provided, so reusing the same date is acceptable
      var seedDate = new Date();


      return CANONICAL_TIMEZONE_NAMES.map(function(timeZoneName) {
         return {
           name: timeZoneName,
           displayName: timeZoneName + ' (UTC' + moment.tz(seedDate, timeZoneName).format('Z') + ')'
         };
       });
    },

    buildTimeDateAndTimezoneString: function() {
      // we could just persist the current values returned by the objects, but instead we're concatenating a string
      // that could be easily parsed by our remote services into actual dates should they need to manipulate the data
      var dateString, timeString, utcOffsetString;

      dateString = moment(this.selectedDate).format('YYYY-MM-DD') + ' ';
      timeString = moment(this.selectedTime).get('hours') + ':' + moment(this.selectedTime).get('minutes') + ' ';
      utcOffsetString = moment().tz(this.selectedTimezone).format('Z') + ' ';

      return dateString + timeString + utcOffsetString + this.selectedTimezone;
    },

    parseDateTimeAndTimezoneString: function(dtzString) {
      var dtzArray = dtzString.split(' ');

      // take the dateTimeTimezone string and split it into its components and map those substrings to values that can
      // be consumed by the individual date, time, and timezone views
      var componentValuesArray = dtzArray.map(function(item, ind) {
        var formattedItem;

        switch (ind) {
          // transform the date string to milliseconds
          case 0:
            formattedItem = moment(item).unix() * 1000;  // returns unix time in seconds, but we want milliseconds
            break;

          // transform the time string to milliseconds for today's date plus the time provided by the string,
          // which is the key for the dropdown items
          case 1:
            var hoursAndMinutes = item.split(':');

            formattedItem = moment().startOf('day')                     // returns today's date at midnight
                                    .add(hoursAndMinutes[0], 'hours')   // add in the hours offset
                                    .add(hoursAndMinutes[1], 'minutes') // add in the minutes offset
                                    .unix() * 1000;                     // returns unix time in seconds, but we want milliseconds
            break;

          // we can return the timezoneName (case 3) and the utc offset (case 2) as is.
          case 2:
          case 3:
            formattedItem = item;
            break;

          default:
            // there is no default case;
        }

        return formattedItem;
      });

      return componentValuesArray;
    },

    // handler for the selection views
    evaluateSelectedDateTimeAndTimezone: function() {
      var answerValueModel;

      // if readonly, or if we have not made a selection for all three selectable items, do nothing
      if (this.getOption('readonly') || !this.selectedDate || !this.selectedTime || !this.selectedTimezone) { return; }

      answerValueModel = this.getAndLinkAnswerValueModel(this.model, this.form);


      this.form.triggerBeginEditAnswerEvent(this, this.model, {
        answerValueModel: answerValueModel
      });

      answerValueModel.set({ value: this.buildTimeDateAndTimezoneString() })

      this.form.triggerEndEditAnswerEvent(this, this.model, {
        answerValueModel: answerValueModel
      });
    },

    // Listeners for the selection views
    onDateViewChangeValue: function(calendarView, redundantCalendarView, newValue, oldValue) {
      this.selectedDate = newValue;
      this.evaluateSelectedDateTimeAndTimezone();
      this.timezoneView.disabled = false;  // enable the timezoneView after a successful answer of the dateView
    },

    onTimeViewChangeValue: function(calendarView, redundantCalendarView, newValue, oldValue) {
      this.selectedTime = newValue;
      this.evaluateSelectedDateTimeAndTimezone();
    },

    onTimezoneViewChangeValue: function(calendarView, redundantCalendarView, newValue, oldValue) {
      this.selectedTimezone = newValue ? newValue.get('name') : null;
      this.evaluateSelectedDateTimeAndTimezone();
    }
  });


  var DateTimeContentView = BaseInputContentView.extend({
    internalViewOptions: BaseInputContentView.extendInternalViewOptions({
      previewAnswerView: function() {
        return {
          type: PreviewAnswerView
        }
      }
    })
  });

  DateTimeContentView.PreviewAnswerView = PreviewAnswerView;

  module.exports = DateTimeContentView;
});

